/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToRem, themeStyleHelper, mediaQuery } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// TITLE : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	title: {
		color: theme.color.supporting.dark.swatch,
		margin: '0 auto',
		position: 'relative',
		'& h1, h2, h3, h4, h5': {
			extend: theme.typography.size.large,
			fontWeight: 'normal',
			marginBottom: pxToRem(10),
			'& .tip': {
				fontSize: '50%'
			}
		},

		// variants
		// this is used on the account settings pages (like users) and also in embed analytics
		'&.variant-withctas': {
            width: '100%',
            minHeight: pxToEm(50),
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
            alignContent: 'center',
            marginBottom: pxToEm(10),
            '& h2, h3, h4, h5': { extend: theme.typography.size.medium, marginBottom: '0', marginRight: pxToEm(20) },
            '& .name-discardchanges':{ marginRight: pxToEm(10) },
            '& .button': { width: pxToEm(213) }
        },
        '&.variant-withtip': {
        	display: 'flex',
        	alignItems: 'center'
        	// '& h2, h3, h4, h5': { extend: theme.typography.size.medium, marginBottom: '0' }
        },

        // names
        '&.name-numberof': {
			'& .total': {
				marginRight: pxToEm(20)
			},
			'& .filtered': {
				color: theme.color.primary.medium.swatch,
				opacity: '0',
				animationName: 'fadeInUp',
                animationDuration: '.2s',
                animationDelay: '0s',
                animationFillMode: 'forwards'
			}
    	},

		// generates classes for every size in the theme ".size-(uniqueColor)"
		extend: themeStyleHelper(theme.typography, 'size', (theme, uniqueProp) => {
			return {
				'& h1, h2, h3, h4, h5': {
					extend: theme.size[uniqueProp]
				}
			}
		})
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.thinnest]: { 
		title: {
			'&.variant-withctas': {
				'& .ctas': {
					marginTop: pxToRem(5)
				}
			}
		}
	}
});